var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _uploadProm, _class2, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { v4 as uuid } from 'uuid';
import { COMMON, UNCOMMON } from 'vagrant/utils/architectures';
import byteFmt from 'vagrant/helpers/format-bytes';
import { ChecksumType } from 'vagrant/utils/checksum-types';
// XHR readyState for done
const XHR_DONE = 4;
const ARCHITECTURES = COMMON.concat(UNCOMMON);
const ARCH_REGEX = new RegExp(`\\b(${ARCHITECTURES.join('|')})\\b`, 'ig');
export let ProviderMeta = (_class = (_uploadProm = /*#__PURE__*/new WeakMap(), class ProviderMeta {
  async upload(api, key, isCookieAuthEnabled = false) {
    const {
      registryId,
      boxId,
      versionId
    } = this.container;
    if (!registryId || !boxId || !versionId) return;

    // External providers auto succeed
    if (this.isExternal) {
      this.succeeded = true;
      return;
    }

    // If there is no file (and not external) auto fail
    if (!this.file || !this.provider) return;
    const {
      url
    } = await api.vagrant.registryServiceApi.uploadBox(registryId, boxId, versionId, this.provider.name ?? '', this.architecture ?? '');
    if (!url) {
      this.failed = true;
      return;
    }
    this.failed = false;
    this.succeeded = false;
    this.progress = 0;
    this.total = 0;
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', ev => {
      this.computeRate(this.progress, ev.loaded);
      this.progress = ev.loaded;
      this.total = ev.total;
    });
    this.trackUpload(xhr);
    const fileData = new FormData();
    fileData.append('file', this.file);
    xhr.responseType = 'json';
    xhr.open('PUT', url);
    if (isCookieAuthEnabled) {
      xhr.withCredentials = true;
    } else {
      xhr.setRequestHeader('Authorization', key);
    }
    xhr.send(fileData);
    await this.waitForUpload();
  }
  waitForUpload() {
    return _classPrivateFieldGet(_uploadProm, this) ?? Promise.resolve();
  }
  trackUpload(xhr) {
    this.uploadReq = xhr;
    const loadend = resolve => () => {
      // It's possible (and always true with Pretender) for a request with an error status
      // to not trigger the error event. This catches those instances.
      if ((this.uploadReq?.status ?? 0) >= 400) {
        this.failed = true;
      } else {
        this.succeeded = true;
      }
      this.uploadReq = undefined;
      resolve();
    };
    const error = reject => () => {
      this.failed = true;
      this.uploadReq = undefined;
      reject();
    };
    _classPrivateFieldSet(_uploadProm, this, new Promise((resolve, reject) => {
      if (xhr.readyState === XHR_DONE) {
        resolve();
      }
      xhr.addEventListener('abort', error(reject));
      xhr.addEventListener('error', error(reject));
      xhr.addEventListener('loadend', loadend(resolve));
    }));
  }
  get isHosted() {
    return !this.isExternal;
  }
  get fileSize() {
    if (!this.file) return null;
    return byteFmt(this.file.size);
  }
  get progressSize() {
    return byteFmt(this.progress);
  }
  get uploadRateFmt() {
    if (!this.uploadReq) return '';
    return byteFmt(this.uploadRate) + '/s';
  }
  constructor(container) {
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "container", void 0);
    _initializerDefineProperty(this, "isExternal", _descriptor, this);
    _initializerDefineProperty(this, "name", _descriptor2, this);
    _initializerDefineProperty(this, "checksumType", _descriptor3, this);
    _initializerDefineProperty(this, "checksum", _descriptor4, this);
    _initializerDefineProperty(this, "file", _descriptor5, this);
    _initializerDefineProperty(this, "externalUrl", _descriptor6, this);
    _initializerDefineProperty(this, "architecture", _descriptor7, this);
    _initializerDefineProperty(this, "isDefault", _descriptor8, this);
    _initializerDefineProperty(this, "provider", _descriptor9, this);
    _initializerDefineProperty(this, "uploadReq", _descriptor10, this);
    _initializerDefineProperty(this, "progress", _descriptor11, this);
    _initializerDefineProperty(this, "total", _descriptor12, this);
    _initializerDefineProperty(this, "uploadRate", _descriptor13, this);
    _initializerDefineProperty(this, "lastMsgTime", _descriptor14, this);
    _initializerDefineProperty(this, "missingArchitecture", _descriptor15, this);
    _initializerDefineProperty(this, "missingHostedFile", _descriptor16, this);
    // UI state based on the status of the upload XHR
    _initializerDefineProperty(this, "failed", _descriptor17, this);
    _initializerDefineProperty(this, "succeeded", _descriptor18, this);
    _classPrivateFieldInitSpec(this, _uploadProm, void 0);
    this.id = uuid();
    this.container = container;
  }
  decorateFile(ev) {
    const file = ev.target.files?.[0];
    this.file = file ?? undefined;
    if (this.file) {
      this.predictArchitecture(this.file.name);
    }
  }
  setChecksumType(type) {
    this.checksumType = type;
    if (type === ChecksumType.NONE) this.checksum = '';
  }
  setExternalUrl(url) {
    this.externalUrl = url;
    this.predictArchitecture(url);
  }
  setArchitecture(arch) {
    this.architecture = arch;
    // Always clear to err on the side of caution
    this.isDefault = false;
  }
  serialize() {
    const {
      name,
      checksumType,
      checksum,
      externalUrl
    } = this;
    const json = {
      name,
      checksumType,
      checksum
    };
    json.type = this.isExternal ? 'external' : 'hosted';
    if (this.isExternal) json.externalUrl = externalUrl;
    return json;
  }
  serializeArchitecture() {
    const json = {
      architectureType: this.architecture,
      boxData: {
        checksum: this.checksum,
        checksumType: this.checksumType ?? 'NONE'
      }
    };
    if (this.isExternal) json.boxData.downloadUrl = this.externalUrl;
    return json;
  }
  predictArchitecture(str) {
    const matches = str.match(ARCH_REGEX);
    if (matches?.length) {
      this.architecture = matches[matches.length - 1]?.toLowerCase();
      this.isDefault = false;
    }
  }
  computeRate(last, current) {
    if (this.lastMsgTime <= 0) {
      // First computation
      this.lastMsgTime = window.performance.now();
      return;
    }
    const now = window.performance.now();
    const numBytes = current - last;
    const numMs = now - this.lastMsgTime;
    this.lastMsgTime = now;
    this.uploadRate = 1000 / numMs * numBytes;
  }
  get percent() {
    if (!this.file) return 0;
    return `${(this.progress / this.file.size * 100).toFixed(2)}%`;
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isExternal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checksumType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ChecksumType.NONE;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "checksum", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "file", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "externalUrl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "architecture", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isDefault", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "provider", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "uploadReq", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "progress", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "total", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "uploadRate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "lastMsgTime", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "missingArchitecture", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "missingHostedFile", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "failed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "succeeded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "decorateFile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "decorateFile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setChecksumType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setChecksumType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setExternalUrl", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setExternalUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setArchitecture", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setArchitecture"), _class.prototype), _class);
let ProviderSet = (_class2 = class ProviderSet {
  constructor() {
    _initializerDefineProperty(this, "providers", _descriptor19, this);
    _defineProperty(this, "registryId", void 0);
    _defineProperty(this, "boxId", void 0);
    _defineProperty(this, "versionId", void 0);
    this.providers = [new ProviderMeta(this)];
  }
  setVersion(registryId, boxId, versionId) {
    this.registryId = registryId;
    this.boxId = boxId;
    this.versionId = versionId;
  }
  add() {
    this.providers = [...this.providers, new ProviderMeta(this)];
  }
  remove(id) {
    const idx = this.providers.findIndex(p => p.id === id);
    this.providers.splice(idx, 1);
    this.providers = this.providers.slice();
  }
  markAsDefault(id, ev) {
    const provider = this.providers.find(p => p.id === id);
    if (!provider) return;
    if (!ev.target.checked) {
      provider.isDefault = false;
    } else {
      const name = provider.name;
      this.providers.filter(p => p.name === name).forEach(p => p.isDefault = false);
      provider.isDefault = true;
    }
  }
  dedupe() {
    // Cache keys to avoid an inner-loop
    const memo = {};
    const toRemove = [];
    this.providers.forEach(p => {
      // Skip incomplete providers
      if (!p.name || !p.architecture) return false;
      const key = `${p.name}::${p.architecture}`;
      if (memo[key]) toRemove.push(p.id);
      memo[key] = true;
    });
    for (const id of toRemove) {
      const idx = this.providers.findIndex(p => p.id === id);
      this.providers.splice(idx, 1);
    }
    this.providers = this.providers.slice();
  }
}, _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "providers", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "add", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "add"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "remove", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "remove"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "markAsDefault", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "markAsDefault"), _class2.prototype), _class2);
export { ProviderSet as default };